function Download() {
  return (
    <svg width={38} height={40} viewBox="0 0 38 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M35.713 25.715c-.789 0-1.428.64-1.428 1.428v8.571c0 .79-.64 1.429-1.429 1.429H4.286c-.79 0-1.429-.64-1.429-1.429v-8.57a1.429 1.429 0 10-2.857 0v8.57A4.286 4.286 0 004.286 40h28.57a4.286 4.286 0 004.286-4.286v-8.57c0-.79-.64-1.43-1.429-1.43z"
        fill="#2c2c2c"
      />
      <path
        d="M26.693 24.704a1.429 1.429 0 00-1.984 0l-4.707 4.704V1.428a1.428 1.428 0 10-2.858 0v27.98l-4.704-4.704a1.429 1.429 0 00-2.02 2.02l7.143 7.142c.557.559 1.462.56 2.02.003l.003-.003 7.142-7.142a1.428 1.428 0 00-.035-2.02z"
        fill="#2c2c2c"
      />
    </svg>
  );
}

export default Download;
